import { attribute } from '../constants';
import infixToPostfixNotation from './infixToPostfixNotation';

var processFieldConditions = function processFieldConditions() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var destinationAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : attribute.CONDITION_POSTFIX;
  var conditionPostfixMemo = {};
  fields.forEach(function (f) {
    if (!f[attribute.CONDITION]) return;

    if (!conditionPostfixMemo[f[attribute.CONDITION]]) {
      conditionPostfixMemo[f[attribute.CONDITION]] = infixToPostfixNotation(f[attribute.CONDITION]);
    }

    f[destinationAttribute] = conditionPostfixMemo[f[attribute.CONDITION]];
  });
  return fields;
};

export default processFieldConditions;